import { type IntlShape } from 'react-intl'

import {
  directContactFormSubjectPolicyGetByTranslatedSubject,
  directContactFormSubjectPolicyGetImageUploadRequirement,
} from '../../direct-contact'

export const directContactFormAccessorShouldShowImageUpload = ({
  intl,
  isLoggedIn,
  subject,
}: {
  intl: IntlShape
  isLoggedIn: boolean
  subject: string
}): boolean => {
  const { policy } = directContactFormSubjectPolicyGetByTranslatedSubject({
    intl,
    subject,
  })

  return (
    directContactFormSubjectPolicyGetImageUploadRequirement({
      imageUploadPolicy: policy.directPageImageUpload,
      isLoggedIn,
      selectedProductTotalCost: 0,
    }) !== 'hidden'
  )
}
